import styled from 'styled-components';
import {Box} from '@sproutsocial/seeds-react-box';
import {Link} from '@sproutsocial/seeds-react-link';
import {Skeleton} from '@sproutsocial/seeds-react-skeleton';
import {pollinateSproutLink} from '../pollination';
import {type TypePageData} from '../services';

const HeroBanner = styled.img`
	width: 100%;
	aspect-ratio: 16 / 9;
	object-fit: cover;
`;

const HeroSkeleton = styled(Skeleton)`
	width: 100%;
	aspect-ratio: 16 / 9;
`;

type TypeFeatureBannerProps = {
	page: TypePageData | null | undefined;
};

export default function FeatureBanner({page}: TypeFeatureBannerProps) {
	if (!page) {
		return (
			<Box display='flex' flexDirection='column'>
				<HeroSkeleton width={1} />
			</Box>
		);
	}

	if (!page?.hero_image_url) return null;

	const {hero_image_url, hero_image_link, page_id} = page;

	const pollinateFeatureBannerClick = () => {
		pollinateSproutLink({feature: 'hero_image', action: `${page_id}_hero_image`, id: page_id});
	};

	return (
		<Box display='flex' flexDirection='column'>
			{hero_image_link ? (
				<Link external href={hero_image_link} onClick={pollinateFeatureBannerClick}>
					<HeroBanner src={`/${hero_image_url}`} alt='' aria-label='Feature Banner' />
				</Link>
			) : (
				<HeroBanner src={`/${hero_image_url}`} alt='' aria-label='Feature Banner' />
			)}
		</Box>
	);
}
